import { createContext } from 'preact';

/** @type {import('preact').Context<{ socket?: import('socket.io-client').Socket, userSocket?: import('socket.io-client').Socket }>} */
export const GlobalsContext = createContext({});
export const ChatContext = createContext({});
